import { render, staticRenderFns } from "./LegacyLayout.vue?vue&type=template&id=acecef08&scoped=true"
import script from "./LegacyLayout.vue?vue&type=script&lang=ts"
export * from "./LegacyLayout.vue?vue&type=script&lang=ts"
import style0 from "./LegacyLayout.vue?vue&type=style&index=0&id=acecef08&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acecef08",
  null
  
)

export default component.exports